import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, SimpleChanges } from '@angular/core';
import { VldGroupDirectiveInterface, VldGroupState } from 'directives/vld-group/vld-group-interface';

@Component({
    selector: 'vld-message',
    templateUrl: 'vld-message.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class VldMessageComponent {
  group: VldGroupDirectiveInterface;
  text: string;
  @Input() validity: string;
  @Input() immediate: boolean;
  @Input() warning: boolean; // if set, the message is a warning, so it doesn't block the form submission

  constructor(private cdr: ChangeDetectorRef, public elementRef: ElementRef) {}

  ngOnChanges(changes: SimpleChanges) {
    void changes;

    if (this.immediate) {
      this.text = this.validity;  
    }

    // safety for calls before initialization
    if (!this.group) {
      return;
    }

    this.updateText();

    // notify the group about the change
    setTimeout(() => this.group.onMessagesChanged());
  }

  updateText() {
    // only show the error if group is "primed" to check for errors (after user clicked next once)
    this.text = this.group.getState() == VldGroupState.Naive ? '' : this.validity;
    this.cdr.markForCheck();
  }
}
